import { createContext } from "react";
import { BlockDefinitionContextValue } from "./types";

export const BlockDefinitionContext = createContext<BlockDefinitionContextValue | null>(null);
